import React from 'react';
import { Label, ToggleSwitch } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { SessionStatus } from '../../../common/enums/SessionStatus';

interface SessionStatusToggleProps {
  status: SessionStatus;
  onStatusChange: (status: SessionStatus) => void;
}

export const SessionStatusToggle: React.FC<SessionStatusToggleProps> = ({
  status,
  onStatusChange,
}) => {
  const { t } = useTranslation();

  const handleToggle = () => {
    const newStatus =
      status === SessionStatus.ACTIVE
        ? SessionStatus.INACTIVE
        : SessionStatus.ACTIVE;
    onStatusChange(newStatus);
  };

  return (
    <div>
      <div className="mb-2 block">
        <Label htmlFor="status" value={t('sessions.status')} />
      </div>
      <ToggleSwitch
        id="status"
        checked={status === SessionStatus.ACTIVE}
        label={t(`status.${status}`)}
        onChange={handleToggle}
      />
    </div>
  );
};
